<template>
	<div class="row offers mt-2">
		<b-col lg="12">
			<div class="card">
				<b-row align-h="center">
					<b-col lg="6">
						<div class="p-2">
							<div class="mt-2 text-center">Search User Ebook</div>
							<b-input-group class="mt-3">
								<b-form-input
									v-model="query_search"
									type="search"
									placeholder="Type to search"
									@change="setQuerySearch"
									trim
								></b-form-input>
								<b-input-group-append>
									<b-button type="submit" variant="primary" @click="asyncFind">Search</b-button>
									<b-button type="button" variant="dark" class="ml-2" @click="asyncClearFind">Clear</b-button>
									<b-spinner v-show="isLoadingSearch" variant="dark" class="ml-2" label="Loading .."></b-spinner>
								</b-input-group-append>
							</b-input-group>
						</div>
					</b-col>
				</b-row>
				<div class="card-body">
					<b-row class="justify-content-end">
						<span class="pr-2">
							<router-link class="btn btn-sm btn-dark" :to="{name: UserEbookCreatePath.name}">
                <em class="fa fa-plus"></em>
              </router-link>
						</span>
						<span>
							<button class="btn btn-sm btn-dark" @click="actionGetUserEbook">
								<em class="fa fa-refresh"></em>
							</button>
						</span>
						<label for="" class="col-sm-auto">Count </label>
						<strong class="col-sm-auto">{{ totalRows }}</strong>
					</b-row>
					<b-table
						:items="items"
						:fields="fields"
						:busy="isLoading"
						:isLoading="isLoading"
						show-empty
						responsive
						class="mt-3"
						hover
					>
						<template v-slot:table-busy>
							<div class="text-center text-dark my-2">
								<b-spinner
									class="align-middle"
									variant="dark"
									type="grow"
									label="Loading .."
								>
								</b-spinner>
								Loading ..
							</div>
						</template>
						<template #cell(No)="row">
							{{ (currentPage - 1) * perPage + (row.index + 1) }}
						</template>
						<template #cell(email)="row">
							{{ row.item.email }}
						</template>
						<template #cell(username)="row">
							{{ row.item.username }}
						</template>
						<template #cell(full_name)="row">
							{{ row.item.full_name }}
						</template>
						<template #cell(last_login)="row">
							{{ formatDate(row.item.last_login) }}
						</template>
						<template #cell(action_edit)="row">
							<router-link class="btn btn-sm btn-default" :to="{name: UserEbookEditPath.name, params: {id: row.item.id}}">
                <em class="fa fa-edit"></em>
              </router-link>
						</template>
					</b-table>
				</div>
				<b-row v-if="(totalRows/perPage) > 1" class="justify-content-start ml-1">
					<b-col lg="3">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							aria-controls="my-table"
						/>
					</b-col>
				</b-row>
			</div>
		</b-col>
	</div>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { UserEbookCreatePath, UserEbookEditPath } from "../../router/account";
export default {
	name: "access-user-ebook",
	data() {
		return {
			UserEbookCreatePath,
			UserEbookEditPath,
			currentPage: 1,
			perPage: 20,
			query_search: '',
			isLoadingSearch: false,
			fields: [
				{ key: "No", label: "No" },
				{
					key: "email",
					label: "Email",
				},
				{ key: "username", label: "Username" },
				{
					key: "full_name",
					label: "Full Name",
				},
				{ key: "last_login", label: "Last Login" },
				{ key: "action_edit", label: "Edit" },
			],
		};
	},
	computed: {
		...mapState({
			isLoading: (state) => state.accessUserEbook.isLoading,
			items: (state) => state.accessUserEbook.items,
			isError: (state) => state.accessUserEbook.isError,
			totalRows: (state) => state.accessUserEbook.totalRows,
		}),
	},
	mounted() {
		this.actionGetUserEbook();
	},
	watch: {
		currentPage: function() {
			this.actionGetUserEbook();
		},
	},
	methods: {
		...mapActions("accessUserEbook", ["fetchUserEbook"]),
		actionGetUserEbook() {
			if (this.query_search == "") {
				let payload = {
					page: this.currentPage,
					limit: this.perPage,
				};
				this.fetchUserEbook(payload);
			} else {
				this.asyncFind();
			}
		},
		...mapActions("accessUserEbook", {
			searchUserEbook: "searchUserEbook"
		}),
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		formatDate(tgl) {
			if (tgl) {
				return moment(tgl).format("DD MMM YYYY hh:mm:ss");
			}
			return "-";
		},
		setQuerySearch(query) {
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				this.query_search = query;
			}, 1000);
		},
		asyncFind() {
			this.isLoadingSearch = true;
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				const query = this.query_search;
				if (!query) {
					this.actionGetUserEbook();
					this.isLoadingSearch = false;
					return;
				}
				this.searchUserEbook({
					q: query,
					page: this.currentPage,
					limit: this.perPage,
				})
					.then((response) => {
						this.items = response.data.data.rows;
						this.isLoadingSearch = false;
					})
					.catch(() => {
						this.isLoadingSearch = false;
					});
			}, 1000);
		},
		asyncClearFind() {
			this.query_search = "";
			this.actionGetUserEbook();
			this.isLoadingSearch = false;
		},
	},
};
</script>
